import { render } from "./BottomStaticMessage.vue?vue&type=template&id=dcd23164"
import script from "./BottomStaticMessage.vue?vue&type=script&lang=js"
export * from "./BottomStaticMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__